import apiClient from './apiClient';

export interface PlanMetrics {
  planId: string;
  planName: string;
  price: number;
  interval: string;
  activeSubs: number;
  mrr: number;
}

export interface OverviewMetrics {
  mrr: number;
  arr: number;
  activeSubscribers: number;
  churnRate: number;
  arpu: number;
  lastSyncedAt: string;
}

export interface RevenueTrendPoint {
  month: string;
  mrr: number;
  newCustomers: number;
}

export interface PriceItem {
  price_id: string;
  amount: number;
  currency: string;
  created: number;
}

export interface ProductWithPrices {
  product_id: string;
  product_name: string;
  monthly_prices: PriceItem[];
  yearly_prices: PriceItem[];
  quarterly_prices: PriceItem[];
}

export interface ActivePriceConfig {
  product_id: string;
  product_name: string;
  monthly: PriceItem;
  yearly: PriceItem;
  quarterly?: PriceItem;
}

export const getStripePlans = async (): Promise<{ plans: PlanMetrics[] }> => {
  const response = await apiClient.get('/admin/stripe/metrics/plans');
  return response.data;
};

export const getOverviewMetrics = async (): Promise<OverviewMetrics> => {
  const response = await apiClient.get('/admin/stripe/metrics/overview');
  return response.data;
};

export const getRevenueTrend = async (
  period: 'month' | 'year' = 'month'
): Promise<RevenueTrendPoint[]> => {
  const response = await apiClient.get('/admin/stripe/metrics/revenue-trend', {
    params: { period },
  });
  return response.data.trends;
};

export const getProductsWithPrices = async (): Promise<ProductWithPrices[]> => {
  const response = await apiClient.get('/admin/stripe/products-with-prices');
  return response.data;
};

export const getActivePriceConfig = async (): Promise<ActivePriceConfig> => {
  const response = await apiClient.get('/stripe/prices');
  return response.data;
};

export const setActivePriceConfig = async (
  monthlyPriceId: string,
  yearlyPriceId: string,
  quarterlyPriceId?: string | null
) => {
  const response = await apiClient.put('/admin/stripe/set-active-price', {
    monthlyPriceId,
    yearlyPriceId,
    quarterlyPriceId: quarterlyPriceId || null,
  });
  return response.data;
};
